module.exports = __webpack_public_path__ + "img/yellow-money-icon.baa7fab7.svg";